// $('.header-bottom__humburger').on('click', function () {
//     $('.header-menu').addClass('active');
//     $('body').css('overflow', 'hidden');
//
//   window.dispatchEvent(new Event('resize'));
// })

$('.header-bottom-new-buttons-left__humburger').on('click', function () {
  $('.header-menu').addClass('active');
  $('body').css('overflow', 'hidden');

  window.dispatchEvent(new Event('resize'));
})

$(document).on('keyup', function(e) {
  if (e.keyCode === 27) {

    let mediaQuery = window.matchMedia("(max-width: 1023px)");

    if (mediaQuery.matches) {
      var menu = document.querySelector(".menu-search.menu-search-hide")
      if (!menu) {
        document.querySelector(".menu-search").classList.add("menu-search-hide");
      }
    }

    $('.header-menu').removeClass('active');
    $(".menu-dropdown").each(function (i, obj) {
      $(obj).slideUp();
    });
  }
})

$('.header-bottom-new-buttons-left__search').on('click', function () {
  var menu = document.querySelector(".menu-search.menu-search-hide")
  if (menu) {
    menu.classList.remove("menu-search-hide");
  }
})

$('.header-menu__close').on('click', function () {
    $('.header-menu').removeClass('active');
    $('body').css('overflow', 'auto');
  window.dispatchEvent(new Event('resize'));
})

$('.product-info__color').on('click', function () {
    $('.product-info__color').removeClass('selected');
    $(this).addClass('selected');
})

$('.product-tabs__nav-item').on('click', function () {
    $('.product-tabs__nav-item').removeClass('active');
    $(this).addClass('active')
    let tab = '#' + $(this).data('id');
   /* $('.product-tabs__item').removeClass('active');
    $(tab).addClass('active');*/
  $([document.documentElement, document.body]).animate({
    scrollTop: $(tab).offset().top - 100
  }, 1000);
})

$('.customer-orders__table-item').on('click', function () {
    $(this).toggleClass('active');
})


$('.header-menu__header-nav__item').on('click', function () {
   $('.header-menu__header-nav__item').removeClass('active')
   $(this).addClass('active');
   let id = '#' + $(this).data('id');
   $('.header-menu__nav').removeClass('active');
   $(id).addClass('active');
})

$('.catalog-filter__parameter').on('click', function () {
    $(this).parent('.catalog-filter__parameter-wrap').toggleClass('active');
})

$('.dropdown-parent').on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = $(this).attr("href");

  // let category_id = $(this).attr("data-category");
    // let element = $("#subcategory-"+category_id);
    // $(".dropdown-parent").each(function (i, obj) {
    //     if(parseInt($(obj).attr("data-category")) !== parseInt(category_id)) {
    //         $("#subcategory-"+$(obj).attr("data-category")).slideUp();
    //         $(obj).find('path').css('fill', '#fff');
    //         $(obj).css('color', '#fff');
    //     }
    // });
    // if($(element).is(":visible")) {
    //     $(this).css('color', '#fff');
    //     $(this).find('path').css('fill', '#fff');
    //     $(element).slideUp();
    // } else {
    //     $(this).css('color', '#019CDE');
    //     $(this).find('path').css('fill', '#019CDE');
    //     $(element).slideDown();
    // }
});


$('.menu-dropdown a').on("click", function (e) {
    e.stopPropagation();
    e.preventDefault();
    window.location.href = $(this).attr("href");
});
